var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashPackagingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#ECFDF3",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M22.9993 25.0833C24.1499 25.0833 25.0827 24.1506 25.0827 23C25.0827 21.8494 24.1499 20.9167 22.9993 20.9167C21.8488 20.9167 20.916 21.8494 20.916 23C20.916 24.1506 21.8488 25.0833 22.9993 25.0833Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9993 22.1667V25.5M27.9993 20.5V23.8333M27.166 16.3333C29.2066 16.3333 30.3103 16.6456 30.8594 16.8879C30.9326 16.9201 30.9691 16.9363 31.0747 17.037C31.1379 17.0974 31.2534 17.2745 31.2831 17.3567C31.3327 17.494 31.3327 17.569 31.3327 17.719V26.676C31.3327 27.4333 31.3327 27.8119 31.2191 28.0065C31.1036 28.2045 30.9922 28.2966 30.776 28.3727C30.5634 28.4475 30.1343 28.365 29.2762 28.2001C28.6755 28.0847 27.9631 28 27.166 28C24.666 28 22.166 29.6667 18.8327 29.6667C16.7921 29.6667 15.6884 29.3544 15.1393 29.1121C15.0661 29.0799 15.0296 29.0637 14.924 28.963C14.8608 28.9027 14.7453 28.7255 14.7156 28.6433C14.666 28.5061 14.666 28.4311 14.666 28.281L14.666 19.324C14.666 18.5667 14.666 18.1881 14.7796 17.9935C14.8951 17.7955 15.0065 17.7034 15.2227 17.6273C15.4353 17.5525 15.8644 17.635 16.7225 17.7999C17.3232 17.9153 18.0356 18 18.8327 18C21.3327 18 23.8327 16.3333 27.166 16.3333ZM25.0827 23C25.0827 24.1506 24.1499 25.0833 22.9993 25.0833C21.8488 25.0833 20.916 24.1506 20.916 23C20.916 21.8494 21.8488 20.9167 22.9993 20.9167C24.1499 20.9167 25.0827 21.8494 25.0827 23Z",
    stroke: "#039855",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPackagingIcon);
export default __webpack_public_path__ + "c96e94d39eba26a54c60a7ed93f26b67.svg";
export { ForwardRef as ReactComponent };